import normalizeSearchState from './normalizeSearchState'
import { CustomSearchState } from '@/types/models'
import { getSessionStorageSearchState } from '@/utils/search/searchState'
import removeEmptyKeysAndValues from '@/utils/removeEmptyKeysAndValues'
import { updateRefinementList } from './updateRefinementList'
import { DISTANCE_OPTIONS } from '../filterOptions/constants'
import { SEARCH_AROUND_ME_LOCATION_NAME } from '../browseBy/constants'

interface RefineSearchStateByUserGeoLoc {
  (props: {
    locationName: string
    locationType?: string
  }): Partial<CustomSearchState>
}

const refineSearchStateByUserGeoLoc: RefineSearchStateByUserGeoLoc = ({
  locationName,
  locationType
}) => {
  const searchState: CustomSearchState = getSessionStorageSearchState() || {}

  const searchStateNormalized = normalizeSearchState({
    ...searchState,
    locationName,
    locationType
  })

  const configureResetToAroundLatLngViaIP = removeEmptyKeysAndValues({
    ...searchStateNormalized.configure,
    aroundLatLng: null,
    aroundRadius: null,
    aroundLatLngViaIP: true,
    aroundPrecision: null
  })

  const updatedRefinements = updateRefinementList({
    refinementList: searchStateNormalized.refinementList || {},
    updates: {
      locations: []
    }
  })
  const clearedSearchState = removeEmptyKeysAndValues({
    ...searchStateNormalized,
    aroundLatLng: false,
    locationName: SEARCH_AROUND_ME_LOCATION_NAME,
    customLocationRadiusInMiles: DISTANCE_OPTIONS.US[3].value.toString(),
    refinementList: updatedRefinements,
    configure: configureResetToAroundLatLngViaIP
  }) as CustomSearchState

  const lastNormalization = normalizeSearchState(clearedSearchState)

  return lastNormalization
}

export default refineSearchStateByUserGeoLoc
